"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contractInterfaces = void 0;
const contractInterfaces = {
  TradeTrustSBT: ["genesis()", "titleEscrowFactory()"],
  TradeTrustTokenMintable: ["mint(address,address,uint256)"],
  TradeTrustTokenBurnable: ["burn(uint256)"],
  TradeTrustTokenRestorable: ["restore(uint256)"],
  TitleEscrow: ["nominate(address)", "transferBeneficiary(address)", "transferHolder(address)", "transferOwners(address,address)", "beneficiary()", "holder()", "active()", "nominee()", "registry()", "tokenId()", "isHoldingToken()", "surrender()", "shred()"],
  TitleEscrowSignable: ["transferBeneficiaryWithSig((address,address,address,address,uint256,uint256,uint256),(bytes32,bytes32,uint8))", "cancelBeneficiaryTransfer((address,address,address,address,uint256,uint256,uint256))"],
  TitleEscrowFactory: ["create(address,address,uint256)", "getAddress(address,uint256)"],
  AccessControl: ["hasRole(bytes32,address)", "getRoleAdmin(bytes32)", "grantRole(bytes32,address)", "revokeRole(bytes32,address)", "renounceRole(bytes32,address)"],
  SBT: ["balanceOf(address)", "ownerOf(uint256)", "transferFrom(address,address,uint256)"]
};
exports.contractInterfaces = contractInterfaces;